export default "__VITE_ASSET__CM$sFnj5__"